const ruleAction = (type, name)=>{
  const message = `Please ${type} ${name}`
  return [{required: true, message: message}]
}

export default {
  companyForm:{
    uid:'',
    company_region: "",
    company_countrycode: "",
    company_zipcode: "",
    company_addressnumber: "",
    company_refinement: "",
    company_street: "",
    company_city: "",
    company_regulateFinancial: false,
    company_registrationNumber: "",
    company_approvedate: "",
    company_email: "",
    company_natureofbusiness: "",
    company_webSite: "",
    company_name: "",
    company_tradingName: "",
    company_telephone: "",
    company_typeOfBusiness: "",

    director_position: "",
    director_identifyNumber: "",
    director_identifyType: "",
    director_identifyExpire: "",
    director_email: "",
    director_name: "",
    director_telephone: "",
    director_dateOfBirth: "",
    director_nationality: "",
    director_residentCountry: "",
    director_region: "",
    director_countrycode: "",
    director_zipcode: "",
    director_addressnumber: "",
    director_refinement: "",
    director_street: "",
    director_city: "",
  },
  mapData(model){
    const formData = {
      venderType: 'railsbank',
      company: {
        region: model.company_region,
        countrycode: model.company_countrycode,
        zipcode: model.company_zipcode,
        addressnumber: model.company_addressnumber,
        refinement: model.company_refinement,
        street: model.company_street,
        city: model.company_city,
        regulateFinancial: model.company_regulateFinancial,
        registrationNumber: model.company_registrationNumber,
        approvedate: model.company_approvedate,
        email: model.company_email,
        natureofbusiness: model.company_natureofbusiness,
        webSite: model.company_webSite,
        name: model.company_name,
        tradingName: model.company_tradingName,
        telephone: model.company_telephone,
        typeOfBusiness: model.company_typeOfBusiness,
      },
      director: {
        position: model.director_position,
        identifyNumber: model.director_identifyNumber,
        identifyType: model.director_identifyType,
        identifyExpire: model.director_identifyExpire,
        email: model.director_email,
        name: model.director_name,
        telephone: model.director_telephone,
        dateOfBirth: model.director_dateOfBirth,
        nationality: model.director_nationality,
        residentCountry: model.director_residentCountry,
        region: model.director_region,
        countrycode: model.director_countrycode,
        zipcode: model.director_zipcode,
        addressnumber: model.director_addressnumber,
        refinement: model.director_refinement,
        street: model.director_street,
        city: model.director_city,
      }
    }
    return formData
  },

  companyRules:{
    // company_region: ruleAction('enter', 'Region'),
    company_countrycode: ruleAction('enter', 'Country code'),
    company_zipcode: ruleAction('enter', 'Zipcode'),
    company_addressnumber: ruleAction('enter', 'Address number'),
    // company_refinement: ruleAction('enter', 'Refinement'),
    company_street: ruleAction('enter', 'Street'),
    company_city: ruleAction('enter', 'City'),
    company_regulateFinancial: ruleAction('enter', 'Regulate Financial'),
    company_registrationNumber: ruleAction('enter', 'Registration Number'),
    company_approvedate: ruleAction('enter', 'Approve Date'),
    company_email: [{
            required: true,
            message: "Please enter your email",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter correct email format",
            trigger: "blur",
          }],
    company_natureofbusiness: ruleAction('enter', 'Nature of Business'),
    company_webSite: ruleAction('enter', 'Website'),
    company_name: ruleAction('enter', 'Company name'),
    company_tradingName: ruleAction('enter', 'Trading Name'),
    company_telephone: ruleAction('enter', 'Telephone'),
    company_typeOfBusiness: ruleAction('enter', 'Type Of Business'),

    director_position: ruleAction('enter', 'Position'),
    director_identifyNumber: ruleAction('enter', 'Identify Number'),
    director_identifyType: ruleAction('enter', 'Identify Type'),
    director_identifyExpire: ruleAction('enter', 'Identify Expire'),
    director_email: [{
            required: true,
            message: "Please enter your email",
            trigger: "blur",
          },
          {
            type: "email",
            message: "Please enter correct email format",
            trigger: "blur",
          }],
    director_name: ruleAction('enter', 'Director'),
    director_telephone: ruleAction('enter', 'Telephone'),
    director_dateOfBirth: ruleAction('enter', 'Date Of Birth'),
    director_nationality: ruleAction('enter', 'Nationality'),
    director_residentCountry: ruleAction('enter', 'Resident Country'),
    // director_region: ruleAction('enter', 'Region'),
    director_countrycode: ruleAction('enter', 'Country code'),
    director_zipcode: ruleAction('enter', 'Zipcode'),
    director_addressnumber: ruleAction('enter', 'Address number'),
    // director_refinement: ruleAction('enter', 'Refinement'),
    director_street: ruleAction('enter', 'Street'),
    director_city: ruleAction('enter', 'City'),
  }
}
